// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dIH9As2UfrYzaL4og5mKbw\\=\\= {\n  width: 100%;\n}\n.ZBPzEbduK3KoymQ0X7zdZQ\\=\\= {\n  padding: 10px;\n}\n.k0hCHGafPaF\\+M8b6gvvUtg\\=\\= {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/assessments/styles/AssessmentLessonList.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb","sourcesContent":[".formControl {\n  width: 100%;\n}\n.assesmentItem {\n  padding: 10px;\n}\n.root {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formControl": "dIH9As2UfrYzaL4og5mKbw==",
	"assesmentItem": "ZBPzEbduK3KoymQ0X7zdZQ==",
	"root": "k0hCHGafPaF+M8b6gvvUtg=="
};
export default ___CSS_LOADER_EXPORT___;
